import Vue from "vue";
import iconfont from "./iconfont.vue";
import BaseButton from "./BaseButton.vue";
import IconTextButton from "./IconTextButton.vue";
import BaseDrawer from "./BaseDrawer.vue";
import NavItems from "./NavItems.vue";
import BaseEmpty from "./BaseEmpty.vue";

Vue.component("iconfont", iconfont);
Vue.component("BaseButton", BaseButton);
Vue.component("IconTextButton", IconTextButton);
Vue.component("BaseDrawer", BaseDrawer);
Vue.component("NavItems", NavItems);
Vue.component("BaseEmpty", BaseEmpty);
